// Het e-mailadres of telefoonnummer van de ontvanger van een herinnering.
// Nodig omdat `TaskReminders.jsx` dit inline deed op een eigen titellijst; het
// huishouden heeft zijn contact nu als vast gegeven (`readHouseholdField`).
// AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T7)

import readHouseholdField from '../adressHelpers/householdFields'

/**
 * @typedef {object} ReminderContactInput
 * @property {string} recipientId - ID van de ontvanger (huishouden, deelnemer of collega)
 * @property {'email'|'sms'} type
 * @property {object|null} [household] - Het `Adresses`-document van de afspraak
 * @property {Array<{PersonaID?: string, Title?: string, Value?: string}>} [contactRows] - Contactregels uit PersonaData
 * @property {Array<{ID: string, Type?: string, Email?: string}>} [recipients] - De kiesbare ontvangers
 */

/**
 * @param {ReminderContactInput} input
 * @returns {string} '' als er niets bekend is
 */
const resolveReminderContact = ({ recipientId, type, household, contactRows = [], recipients = [] }) => {
    if (!recipientId) return ''

    const teamMember = recipients.find((r) => r.ID === recipientId && r.Type === 'team')
    if (teamMember) return type === 'email' ? (teamMember.Email || '') : ''

    // Een huishouden leest zijn vaste veld; een deelnemer heeft dezelfde
    // titels in PersonaData, dus dezelfde lezing zonder eigen veld.
    const bron = household && household.ID === recipientId ? household : { ID: recipientId }
    const rows = contactRows.filter((row) => row?.PersonaID === recipientId)
    return String(readHouseholdField(bron, rows, type === 'email' ? 'Email' : 'Telefoon') || '')
}

export default resolveReminderContact
